import { Breakpoint, Container, SxProps, Theme } from '@mui/material';

interface FormStepContentContainerProps {
  children: React.ReactNode;
  sx?: SxProps<Theme> | undefined;
  maxWidth?: Breakpoint;
}

export const FormStepContentContainer: React.FC<
  FormStepContentContainerProps
> = ({ children, sx, maxWidth }) => {
  return (
    <Container maxWidth={maxWidth ? maxWidth : 'sm'} sx={{ mx: 'auto', ...sx }}>
      {children}
    </Container>
  );
};
